import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useState, useEffect, createElement } from 'react';

const FAQDetail = ({ blockId, profile, isPremium }) => {
  const { classes, css } = useStyles(styles);

  const [content, setContent] = useState({})

  const { NX_PROXY_API } = process.env;
  
  async function getNotionData() {

    let response = ""

    if(profile === "BUSINESS" && !isPremium){
      response = await fetch(`${NX_PROXY_API}/notion/faq/business/${blockId}?mode=flat`);
    } else if (profile === "SCHOOL" && !isPremium){
      response = await fetch(`${NX_PROXY_API}/notion/faq/school/${blockId}?mode=flat`);
    } else if (profile === "INDIVIDUAL"){
      response = await fetch(`${NX_PROXY_API}/notion/faq/student/${blockId}?mode=flat`);
    } else if (profile === "BUSINESS" && isPremium){
      response = await fetch(`${NX_PROXY_API}/notion/faq/businessPremium/${blockId}?mode=flat`);
    } else if (profile === "SCHOOL" && isPremium){
      response = await fetch(`${NX_PROXY_API}/notion/faq/schoolPremium/${blockId}?mode=flat`);
    }else if (profile === "CFA") {
      response = await fetch(`${NX_PROXY_API}/notion/faq/cfa/${blockId}?mode=flat`);
    }

    const getAnnotations = (text) => {
      const classNames = [];

      text?.annotations?.bold && classNames.push(classes.bold);
      text?.annotations?.italic && classNames.push(classes.italic);
      text?.annotations?.strikethrough && classNames.push(classes.strikethrough);
      text?.annotations?.underline && classNames.push(classes.underline);

      return classNames;
    };

    const getFinalText = (text) => {
      let finalText = text.map((text, index) => {
        const classNames = getAnnotations(text);
        return (
          <span key={index} className={classNames.length > 0 ? classNames.join(' ') : undefined}>
            {text?.href ? <a href={text.href}>{text.plain_text}</a> : text.plain_text}
          </span>
        );
      });
      return finalText;
    };


    const data = await response.json();
    const elements = [];
    data.results && data.results.forEach((element) => {

      const typeMappings = {
        paragraph: { tag: 'p', className: classes.text },
        heading_1: { tag: 'h1', className: classes.h1 },
        heading_2: { tag: 'h2', className: classes.h2 },
        heading_3: { tag: 'h3', className: classes.h3 },
        heading_4: { tag: 'h4', className: classes.h4 },
        heading_5: { tag: 'h5', className: classes.h5 },
        heading_6: { tag: 'h6', className: classes.h6 },
      };
      const type = element.type;

      if (type === "unsupported") return;
      
      if (element[type]?.rich_text && typeMappings[type]) {
        const { tag, className } = typeMappings[type];
        const finalText = getFinalText(element[type].rich_text);
        if(finalText.length > 0)
          elements.push(createElement(tag, { className }, finalText));
        else{
          elements.push(createElement(tag, { className: classes.divider }, finalText));
        }
      }

      if (type === "image") {
        elements.push(<img className={classes.image} src={element[type].file.url} alt="image"/>);
      }
      if (type === "bulleted_list_item") {
        elements.push(<li className={classes.bulletList}>{element[type].rich_text[0].plain_text}</li>);
      }
      if (type === "numbered_list_item") {
        elements.push(<li className={classes.bulletList}>{element[type].rich_text[0].plain_text}</li>);
      }
      if (type === "divider") {
        elements.push(<hr />);
      }
      if (type === "callout") {
        elements.push(<blockquote>{element[type].rich_text[0].plain_text}</blockquote>);
      }
      if (type === "embed") {
        const embedUrl = element[type].url;
        elements.push(<iframe className={classes.embed} src={embedUrl} height="1000px" title="Embedded Content" />);
      }
    });
      setContent(elements);
    }

  useEffect(() => {
    if(blockId)
      getNotionData();
      }, [blockId]);

  return (
      <section className={css({minWidth: '100%'})}>
        {content.length > 0 ? content : 'Chargement...'}
      </section>
  );
};


const styles = () => ({
  image: {
    maxWidth: '100%',
  },
  text: {
    fontSize: '13.500px',
    color: '#152652',
  },
  h2: {
    fontSize: '15.0px',
    fontWeight: 600,
    color: '#152652',
  },
  bulletList: {
    fontSize: '13.500px',
    color: '#152652',
    listStyle: 'disc',
  },
  bold: {
    fontWeight: 600,
  },
  italic: {
    fontStyle: 'italic',
  },
  strikethrough: {
    textDecoration: 'line-through',
  },
  underline: {
    textDecoration: 'underline',
  },
  divider: {
    padding: '10px',
  },
  embed: {
    width: '100%',
    minHeight: '100%',
  },
});

FAQDetail.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  onCancel: PropTypes.func,
};

export default FAQDetail;